import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import WhitelistRequestLayer from "../../components/Whitelist Request/WhitelistRequestLayer";

const WhiteListRequestPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Whitelist Request" />

        <WhitelistRequestLayer />
      </MasterLayout>
    </>
  );
};

export default WhiteListRequestPage;
